import { render, staticRenderFns } from "./toolbars.vue?vue&type=template&id=bcee62a8"
import script from "./toolbars.vue?vue&type=script&lang=js"
export * from "./toolbars.vue?vue&type=script&lang=js"
import style0 from "./toolbars.vue?vue&type=style&index=0&id=bcee62a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports